import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../state'
import { NavigationLinkDirective } from '../../../navigation-link.directive'
import { Store } from '../../store'

@ngCore.Component({
  imports: [NavigationLinkDirective],
  selector: 'atn-navbar-app-utilities',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link ents.core.admin.App.ForUser} */
  public readonly appSg = ngCore.input.required<ents.core.admin.App.ForUser>({
    alias: 'app',
  })
}
